import { FilterOperators, FilterTypes } from "@/data/table";
import {
  EmailFilter,
  FirstNameFilter,
  LastNameFilter
} from "@/data/filters/client";
import i18n from "@/i18n";
import { CreatedAtFilter } from "@/data/filters/object";

export const LoginAsChild = () => ({
  key: "allow_impersonation",
  label: i18n.t("_sentence.login_as_child_qn"),
  type: FilterTypes.SELECT_RADIO,
  operator: FilterOperators.EQUAL,
  value: "1"
});

export const InheritPaymentDetails = () => ({
  key: "inherit_payment_details",
  label: i18n.t("_sentence.inherit_payment_details_qn"),
  type: FilterTypes.SELECT_RADIO,
  operator: FilterOperators.EQUAL,
  value: "1"
});

export const DefaultFilters = () => [
  FirstNameFilter({ key: "child_client.firstname" }),
  LastNameFilter({ key: "child_client.lastname" }),
  EmailFilter({ key: "child_client.default_email.email" }),
  LoginAsChild(),
  InheritPaymentDetails(),
  CreatedAtFilter()
];
